import createReducer from 'utils/redux/createReducer'

// TODO: initialState must be constant
const initialState = {
  open: "true",
  owner: 'Me&Unasigned',
  landlord: 'All',
  property: 'All',
  tenant: 'All',
  dueFrom: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000),
  dueTo: new Date(new Date().valueOf() + 7 * 24 * 60 * 60 * 1000),
  minDue: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000),
  maxDue: new Date(new Date().valueOf() + 7 * 60 * 60 * 1000),
  taskType: 'All'
}

export default createReducer(initialState, {
	TASK_FILTER_UPDATED: (currentState, action) => (
		{
			owner: (action.data.owner)? action.data.owner : currentState.owner
		  , property: (action.data.property)? action.data.property : currentState.property
		  , open: (action.data.open)? action.data.open : currentState.open
		  , dueFrom: (action.data.dueFrom)? new Date(action.data.dueFrom) : currentState.dueFrom
		  , dueTo: (action.data.dueTo)? new Date(action.data.dueTo) : currentState.dueTo
		  , minDue: (action.data.dueFrom)? new Date(action.data.dueFrom) : currentState.dueFrom
		  , maxDue: (action.data.dueTo)? new Date(action.data.dueTo) : currentState.dueTo
		  , taskType: (action.data.taskType)? action.data.taskType : currentState.taskType
		}
	)
  , CLEAR_TASK_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/taskFilters.js